import { TooltipInput, TooltipItem } from '@/lib/types';
import { api } from '@/lib/utils/api.axios';
import { apiBasePaths } from '@/lib/queries';

const BASE_URL = `${apiBasePaths.user}/v1/tooltips`;

export const getTooltips = () =>
  api.get<TooltipItem[]>(BASE_URL).then((response) => response.data);

export const createTooltip = (tooltip: TooltipInput) =>
  api.post<TooltipItem>(BASE_URL, tooltip).then((response) => response.data);

export const updateTooltip = (id: TooltipItem['id'], tooltip: TooltipInput) =>
  api
    .put<TooltipItem>(`${BASE_URL}/${id}`, tooltip)
    .then((response) => response.data);

export const deleteTooltip = (id: TooltipItem['id']) =>
  api.delete(`${BASE_URL}/${id}`);
